import React,{ useContext} from "react";
import workarea from "../asset/1.png";
import "../css/workarea.css";
import DataDescriptionContext from "../context/DataDescriptionContext";


const Workarea = () => {
  let {selectedFile,isSelected,handleSubmit,cancelUpload,getRootProps,getInputProps, style} = useContext(DataDescriptionContext);

  return (
    <div className="container-fluid bg-light w-auto rounded mx-3 workarea">
     
      {isSelected ? (
        
        <div className="workimg">
          <h2>file details</h2>
          <p>Filename: {selectedFile.name}</p>
          <p>FileType: {selectedFile.type}</p>
          <p>Size in byte:{selectedFile.size}</p>
          <button className="btn btn-success mx-2 my-2" onClick={handleSubmit}>Upload</button>
          <button className="btn btn-danger mx-2 my-2" onClick={cancelUpload}>Cancel</button>
          </div>
      ):
      (
        <div className="workimg" {...getRootProps({style})}>
        <input {...getInputProps()}/>
        <img className='rounded h-30 w-30' src={workarea} alt="Workarea"></img>
        <h4 className="my-2">Drag and Drop Your Dataset.</h4>
      </div>
      )}
      
    </div>
  );
};

export default Workarea;
